import React from "react";
import styles from "./Login.module.less";
import Image from "next/image";
import logo from "@aspen/assets/images/aspen_logo_black.webp";
import { handleBlur, handleFocus, i18nUtil } from "@aspen/libs";
import LanguageSwitch from "./LanguageSwitch";
import clsx from "clsx";
import DownloadAppQrCode from "./DownloadAppQrCode";

export const LoginLayoutPortal = WrappedComponent => {
  const LoginPortal = props => {
    const intl = i18nUtil.t();

    return (
      <section className={clsx(styles.login, "login")}>
        <LanguageSwitch />
        <div className={styles.main}>
          <div className={styles.mainContainer}>
            <DownloadAppQrCode />
            <section className={styles.leftBrief}>
              <div className={styles.logo}>
                <Image unoptimized src={logo} alt="logo" />
              </div>
              <p className={styles.title}>{intl["login.title"]}</p>
            </section>
            <WrappedComponent {...props} handleFocus={handleFocus} handleBlur={handleBlur} />
          </div>
        </div>
      </section>
    );
  };

  return LoginPortal;
};
